/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createComplexClass } from '../../factoriesAny.js';
export var ComplexDependencies = {
  createComplexClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesComplexClass.generated.js
// module id = w9uV
// module chunks = 3